(() => {
  const root = document.documentElement;
  root.classList.add('iyrs-storefront-v2');

  const legacyClasses = ['iyrs-storefront-architecture-v1', 'iyrs-ux-v1'];
  const legacyNodes = [
    '.iyrs-ux-purchase-trust',
    '.iyrs-ux-category-system',
    '.iyrs-ux-reviews',
    '.iyrs-ux-instagram',
    '.iyrs-v2-trust-strip',
    '.iyrs-v2-category-system',
    '.iyrs-v2-wholesale-cta',
    '.iyrs-v2-reviews'
  ].join(',');

  const removeLegacyRuntimeEnhancements = () => {
    for (const className of legacyClasses) {
      if (root.classList.contains(className)) root.classList.remove(className);
    }
    if (document.body?.classList.contains('iyrs-storefront-architecture-v1')) {
      document.body.classList.remove('iyrs-storefront-architecture-v1');
    }
    document.querySelectorAll(legacyNodes).forEach((node) => node.remove());
  };

  const disableSddBobRuntimeEffects = () => {
    if (!document.body?.classList.contains('google-hero1-v2')) return;
    document.querySelector('.m-page-transition')?.remove();
    root.classList.remove('m:overflow-hidden');
    document.body.classList.remove('m:overflow-hidden');
  };

  // Native details stay genuinely open in the desktop footer grid.
  // Preserve the rendered/mobile state when crossing the existing 768px breakpoint.
  const footerDesktop = window.matchMedia('(min-width: 768px)');
  const footerMobileState = new WeakMap();
  const footerGroups = () => document.querySelectorAll('.iyrs-v2-footer__nav details');
  const setFooterDesktop = (details) => {
    details.open = true;
    const summary = details.querySelector('summary');
    summary.setAttribute('tabindex', '-1');
    summary.setAttribute('aria-disabled', 'true');
  };
  const initFooterDisclosure = () => {
    footerGroups().forEach((details) => {
      if (!footerMobileState.has(details)) {
        const summary = details.querySelector('summary');
        footerMobileState.set(details, {
          open: details.open,
          tabindex: summary.getAttribute('tabindex'),
          disabled: summary.getAttribute('aria-disabled')
        });
      }
      if (footerDesktop.matches) setFooterDesktop(details);
    });
  };
  footerDesktop.addEventListener('change', () => {
    footerGroups().forEach((details) => {
      const state = footerMobileState.get(details);
      if (!state) return;
      if (footerDesktop.matches) {
        state.open = details.open;
        setFooterDesktop(details);
      } else {
        details.open = state.open;
        const summary = details.querySelector('summary');
        for (const [name, value] of [['tabindex', state.tabindex], ['aria-disabled', state.disabled]]) {
          if (value === null) summary.removeAttribute(name);
          else summary.setAttribute(name, value);
        }
      }
    });
    initFooterDisclosure();
  });

  const finishLegacyCleanup = () => {
    initFooterDisclosure();
    removeLegacyRuntimeEnhancements();
    disableSddBobRuntimeEffects();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', finishLegacyCleanup, { once: true });
  } else {
    finishLegacyCleanup();
  }
  document.addEventListener('shopify:section:load', finishLegacyCleanup);

  const closeDesktopShop = (except) => {
    document.querySelectorAll('.iyrs-v2-nav details[open]').forEach((details) => {
      if (details !== except) details.removeAttribute('open');
    });
  };

  document.addEventListener('click', (event) => {
    if (footerDesktop.matches && event.target.closest('.iyrs-v2-footer__nav summary')) event.preventDefault();
    const activeDetails = event.target.closest('.iyrs-v2-nav details');
    if (activeDetails) closeDesktopShop(activeDetails);
    else closeDesktopShop();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDesktopShop();
  });
})();
